import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import TitledForm from "../../Helpers/TitledForm";
import { Switch, Route, Redirect } from "react-router";
import FormView from "../../FormView";
import FormNavigator from "../../Helpers/FormNavigator";
import LocationFields from "../LocationFields";
import ApartmentTypeFields from "../ApartmentTypeFields";
import ApartmentResultsFields from "../ApartmentResultsFields";
import ProfileFields from "../ProfileFields";
import CompanyFields from "../CompanyFields";
import AccountFields from "../AccountFields";
import SignUpForm from "../Form";
import LoginSuggestion from "../../Helpers/LoginSuggestion";
import Progress from "../../SidePanel/Progress";
import StickyFields from "./StickyFields";
import MapSelectionField from "../LocationFields/MapSelectionField";
import TenantPropertyFilters from "./TenantPropertyFilters";
import { Field, change } from "redux-form";
import SignUpStatus from "../../Helpers/SignUpStatus";
import { signUp } from "../../../actions/signUpActions";
import { validateProperty, tenantPropertyFields as propertyFields } from "../../../actions/validation";

const steps = [
    {
        title: "Search Properties",
        nav: "Search",
        PageFields: StickyFields
    },
    {
        title: "Interior Design",
        subtitle: "Choices including kitchen, toilet, etc.",
        nav: "Interior Design",
        PageFields: ApartmentTypeFields,
        props: { mode: "interior" }
    },
    {
        title: "Facilities & Security",
        subtitle: "Including 24/7 surveillance, drive-in, etc.",
        nav: "Facilities & Security",
        PageFields: ApartmentTypeFields,
        props: { mode: "security" }
    },
    {
        title: "3 results with available property spaces found",
        nav: "Property Results",
        PageFields: ApartmentResultsFields
    },
    {
        title: "Your Details",
        subtitle: "Sopia needs this information to find a suitable property for you.",
        nav: "Your Profile",
        PageFields: ProfileFields
    },
    {
        title: "Company Details",
        subtitle: "Please provide information about your company.",
        nav: "Company Details",
        PageFields: CompanyFields
    },
    {
        title: "Track your progress with an Sopia account:",
        nav: "Account information",
        PageFields: AccountFields
    }
]

export default class TenantSignUp extends Component {
    //this.handleSubmit is the ref of the local handleSubmit function
    //bind here clearly links the local handlesubmit functions on "this(local obj)"
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setValidity = this.setValidity.bind(this);
        this.state = {
            validity: undefined,
            max: 0
        }
    }

    setValidity(values) {
        const validity = validateProperty(values, false);
        console.log('validity', validity)
        const keys = Object.keys(validity);
        let earliestError = undefined;
        if (keys.length > 0) {
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                for (let j = 0; j < propertyFields.length; j++) {
                    if (propertyFields[j][key] === true) {
                        earliestError = earliestError === undefined ? j : Math.min(j, earliestError);
                        break;
                    }
                }
            }
        }
        const max = (earliestError === undefined) ? Number.POSITIVE_INFINITY : earliestError;
        // console.log( 'VALIDITY >>', validity, 'MAX >>', max ); // DEBUG
        this.setState({
            validity,
            max
        });
    }

    isValid(validity) {
        return validity !== undefined && !Object.keys(validity).length;
    }

    handleChange(values, dispatch, props, previousValues) {
        this.setValidity(values);
    }

    handleSubmit(values, dispatch, props) {
        this.props.setEmail(values.email);
        dispatch(signUp({ isLandlord: false, ...values }));
    }

    componentDidMount() {
        this.props.clearSignUp();
    }

    componentWillUnmount() {
        this.props.clearSignUp();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.formValues !== this.props.formValues) {
            this.setValidity(this.props.formValues);
        }
    }

    render() {
        // <TenantForm onChange={this.handleChange} onSubmit={this.handleSubmit}/>
        // Route render attribute is used for inline route rendering, it means instead of using a
        // component attribute at Route, we can use inline logic
        return (
            <Switch>
                <Route exact path="/signup/tenant/:index" render={(ps) => {
                    //ps.match.params.index means paths index (:index)
                    const index = Number(ps.match.params.index);
                    const { form } = this.props;
                    const disableProgress = this.state.max <= index;
                    // console.log( index );
                    const isFirst = index <= 0;
                    const formProps = {
                        tenant: true,
                        form,
                        onChange: this.handleChange,
                        onSubmit: this.handleSubmit,
                        validity: this.state.validity,
                        dispatch: this.props.dispatch
                    };

                    const isLast = index >= (steps.length - 1);

                    if (index < 0 || index >= steps.length)
                        return <Redirect to={"/signup"} />;

                    // const isFinal = index >= ( steps.length - 1 );
                    const { title, subtitle } = steps[index] || {};

                    return (
                        <FormView
                            topContent={
                                <Fragment>
                                    <Progress
                                        steps={steps.map((step) => step.nav)}
                                        resource="/signup/tenant/"
                                        title={null}
                                        max={this.state.max}
                                        current={index}
                                        disableProgress={disableProgress}
                                        horizontal
                                    />
                                    <TenantPropertyFilters />
                                </Fragment>
                            }
                            content={
                                <div style={{ width: '100%' }}>
                                    <form onSubmit={this.props.handleSubmit(this.handleSubmit)}>
                                        <div className={(index >= 0 && index <= 6) ? "responsive-hide" : ""}>
                                            <TitledForm
                                                stretch
                                                titleAlign="left"
                                                titleSize="wide"
                                                formSize="wide"
                                                formAlign="stretch"
                                                title={title}
                                                subtitle={subtitle}
                                                form={
                                                    <SignUpForm step={steps[index]} {...formProps} {...(steps[index].props || {})} />
                                                }
                                                footer={
                                                    <Fragment>
                                                            <FormNavigator
                                                                back={"/signup/" + String(isFirst ? "" : ("tenant/" + String(index - 1)))}
                                                                continue={"/signup/tenant/" + (isLast ? "submit" : String(index + 1))}
                                                                isLast={isLast}
                                                                compact={false}
                                                                onSubmit={this.props.handleSubmit(this.handleSubmit)}
                                                                disabled={disableProgress}
                                                            />
                                                        <div className="responsive-hide">
                                                            <LoginSuggestion />
                                                        </div>
                                                        <SignUpStatus />
                                                    </Fragment>
                                                }
                                            />
                                        </div>
                                        {(index >= 0 && index <= 6) && (
                                            <div className="responsive-show-compact" style={(index !== 0 && index !== 3) ? { paddingTop: index === 4 ? '0.75rem' : '1.5rem', paddingBottom: '1rem' } : {}}>
                                                <SignUpForm step={steps[index]} {...formProps} {...(steps[index].props || {})} />
                                                <div style={{ marginTop: '0.5rem' }}>
                                                    <FormNavigator
                                                        back={"/signup/" + String(isFirst ? "" : ("tenant/" + String(index - 1)))}
                                                        continue={"/signup/tenant/" + (isLast ? "submit" : String(index + 1))}
                                                        isLast={isLast}
                                                        compact={true}
                                                        onSubmit={this.props.handleSubmit(this.handleSubmit)}
                                                        disabled={disableProgress}
                                                    />
                                                    <SignUpStatus />
                                                </div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            }
                            sideContent={null}
                            mapContent={
                                <div style={{ height: '100%', width: '100%' }}>
                                    <Field
                                        name="address"
                                        component={MapSelectionField}
                                        tenant={true}
                                        onLocationUpdate={(state) => {
                                            const { dispatch, form } = this.props;
                                            dispatch(change(form, "location", state.location));
                                            dispatch(change(form, "address", state.address));
                                            dispatch(change(form, "radius", state.radius));
                                        }}
                                    />
                                    {/* <div style={{ padding: '1.5rem', marginTop: '1rem', backgroundColor: '#f0f4f8', borderRadius: '8px' }}>
                                        <Typography variant="h6" color="primary" gutterBottom>
                                            Select Your Search Area
                                        </Typography>
                                        <Typography variant="body1">
                                            Please use the map above to select your preferred location and search radius.
                                            The address will update automatically as you move the marker.
                                        </Typography>
                                    </div> */}
                                </div>
                            }
                        />
                    );
                }} />
                <Redirect to="/signup/tenant/0" />
            </Switch>
        );
    }

}

TenantSignUp.propTypes = {
    onChange: PropTypes.func,
}